// import React, { useState } from 'react';
// import { toast } from 'react-toastify';
// import { useDispatch } from 'react-redux';
// import { useMutation } from '@apollo/client';
// import { Button, TabContent, TabPane } from 'reactstrap';
// import { ADD_EDIT_CONSTANT } from 'utils/constants';
// import { setStaffDetails } from 'actions/staffDetailsAction';
// import FSBModal from 'components/common/FSBModal';
// import CustomTabs from 'components/CustomTabs';
// import Heading from 'components/Heading';
// import { IoMdAdd } from 'react-icons/io';
// import { role } from 'config/role';
// import DeleteConfirmationAlert from 'components/DeleteConfirmationAlert';
// import Logistics from './components/Logistics';
// import Accounts from './components/Accounts';
// import SalesAndMarketing from './components/SalesAndMarketing';
// import AddEditStaff from './components/AddEditStaff';
// import AllStaffList from './components/AllStaffList';
// import { STAFF_HEADING } from './constant';
// import { DELETE_STAFF } from './StaffgraphQL';
// import CommonStaffList from './components/CommonStaffList';

// const Staff = () => {
//   const dispatch = useDispatch();
//   const [deleteRecord, setDeleteRecord] = useState({ status: false, id: '' });
//   const [activeTab, setActiveTab] = useState('All');
//   const [isDrawerOpen, setIsDrawerOpen] = useState(false);
//   const [showAddRecord, setShowAddRecord] = useState({
//     type: ADD_EDIT_CONSTANT.ADD,
//     value: '',
//     refetch: () => {},
//   });
//   const [deleteUser] = useMutation(DELETE_STAFF, {
//     // eslint-disable-next-line no-shadow
//     onCompleted: ({ deleteUser }) => {
//       toast.success(deleteUser);
//       setDeleteRecord({ status: !deleteRecord.status, id: '' });
//     },

//     onError: ({ graphQLErrors }) => {
//       graphQLErrors.map(({ message }) => {
//         toast.error(message);
//         return message;
//       });
//       setDeleteRecord({ status: !deleteRecord.status, id: '' });
//     },
//   });
//   const toggle = (tab) => {
//     if (activeTab !== tab) setActiveTab(tab);
//   };

//   const handleViewDetail = (data) => {
//     dispatch(setStaffDetails({ status: true, selectedStaff: data }));
//   };

//   const toggleDeleteRecord = (id) => {
//     setDeleteRecord({ status: !deleteRecord.status, id });
//   };

//   const onDeleteConfirmation = async () => {
//     try {
//       await deleteUser({
//         variables: { id: deleteRecord.id },
//       });
//     } catch (err) {
//       toast.error(err);
//     }
//   };

//   const drawerToggle = () => {
//     setIsDrawerOpen(!isDrawerOpen);
//     // showAddRecord.refetch();
//   };

//   const toggleAddRecord = (value, type, refetch) => {
//     setIsDrawerOpen(!isDrawerOpen);
//     setShowAddRecord({ type, value, refetch });
//   };

//   return (
//     <div className="staff-page">
//       <div className="mb-3 top-head">
//         <Heading title="Staff" />
//       </div>
//       <div className="d-md-flex align-items-center justify-content-between">
//         <CustomTabs
//           tabs={[
//             STAFF_HEADING.ALL,
//             STAFF_HEADING.LOGISTICS,
//             STAFF_HEADING.ACCOUNTS,
//             STAFF_HEADING.SALESANDMARKETING,
//             STAFF_HEADING.BDE,
//             // STAFF_HEADING.RESOURCEMANAGER,
//           ]}
//           selectedTab={activeTab}
//           onTabChange={toggle}
//           // className="full-border-tab mb-2 mb-md-3"
//         />
//         <div className="text-end">
//           <Button
//             color="primary"
//             className="text-nowrap staff-add-btn position-absolute p-0 rounded-btn rounded-circle d-flex align-items-center justify-content-center"
//             size="sm"
//             onClick={() => toggleAddRecord('', ADD_EDIT_CONSTANT.ADD)}
//           >
//             <IoMdAdd color="#fff" size={20} />
//           </Button>
//         </div>
//       </div>
//       <DeleteConfirmationAlert
//         open={deleteRecord.status}
//         title="Delete"
//         message="Do you really want to remove this record?"
//         cancelButtonLabel="Close"
//         addButtonLabel="Delete"
//         onConfirm={onDeleteConfirmation}
//         onCancel={toggleDeleteRecord}
//       />
//       <FSBModal
//         title={`${showAddRecord.type} Staff`}
//         message=""
//         open={isDrawerOpen}
//         toggleAlert={drawerToggle}
//         onClose={drawerToggle}
//         modalClass="right-drawer"
//       >
//         <AddEditStaff
//           toggleAddRecord={toggleAddRecord}
//           type={showAddRecord.type}
//           value={showAddRecord.value}
//           drawerToggle={drawerToggle}
//           // currentRow={addEditRecord.row}
//           // type={addEditRecord.type}
//           // handleAddEditRecord={handleAddEditRecord}
//         />
//       </FSBModal>

//       {/* role permission modal */}
//       {/* <FSBModal
//         title="Role Permission"
//         open={isRoleDrawerOpen}
//         toggleAlert={drawerRoleToggle}
//         onClose={drawerRoleToggle}
//         message=""
//         modalClass="right-drawer"
//       >
//         <RolePermissions />
//       </FSBModal> */}

//       <TabContent activeTab={activeTab} className="position-relative">
//         <TabPane tabId={STAFF_HEADING.ALL}>
//           {activeTab === STAFF_HEADING.ALL && (
//             <AllStaffList
//               handleViewDetail={handleViewDetail}
//               toggleAddRecord={toggleAddRecord}
//               handleDelete={toggleDeleteRecord}
//             />
//           )}
//         </TabPane>
//         <TabPane tabId={STAFF_HEADING.LOGISTICS}>
//           {activeTab === STAFF_HEADING.LOGISTICS && (
//             <Logistics
//               handleViewDetail={handleViewDetail}
//               toggleAddRecord={toggleAddRecord}
//               handleDelete={toggleDeleteRecord}
//             />
//           )}
//         </TabPane>
//         <TabPane tabId={STAFF_HEADING.ACCOUNTS}>
//           {activeTab === STAFF_HEADING.ACCOUNTS && (
//             <Accounts
//               handleViewDetail={handleViewDetail}
//               toggleAddRecord={toggleAddRecord}
//               handleDelete={toggleDeleteRecord}
//             />
//           )}
//         </TabPane>
//         <TabPane tabId={STAFF_HEADING.SALESANDMARKETING}>
//           {activeTab === STAFF_HEADING.SALESANDMARKETING && (
//             <SalesAndMarketing
//               handleViewDetail={handleViewDetail}
//               toggleAddRecord={toggleAddRecord}
//               handleDelete={toggleDeleteRecord}
//             />
//           )}
//         </TabPane>
//         <TabPane tabId={STAFF_HEADING.BDE}>
//           {activeTab === STAFF_HEADING.BDE && (
//             <CommonStaffList
//               handleViewDetail={handleViewDetail}
//               toggleAddRecord={toggleAddRecord}
//               handleDelete={toggleDeleteRecord}
//               satffType={role.BDE}
//             />
//           )}
//         </TabPane>
//         {/* <TabPane tabId={STAFF_HEADING.RESOURCEMANAGER}>
//           {activeTab === STAFF_HEADING.RESOURCEMANAGER && (
//             <ResourceManager
//               handleViewDetail={handleViewDetail}
//               toggleAddRecord={toggleAddRecord}
//               handleDelete={toggleDeleteRecord}
//             />
//           )}
//         </TabPane> */}
//       </TabContent>
//     </div>
//   );
// };

// export default Staff;

// This was Edit icon on staff code -------------------------------

import React, { useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { Button, TabContent, TabPane } from 'reactstrap';
import { ADD_EDIT_CONSTANT, defaultDeleteFilter } from 'utils/constants';
import { setStaffDetails } from 'actions/staffDetailsAction';
import FSBModal from 'components/common/FSBModal';
import CustomTabs from 'components/CustomTabs';
import Heading from 'components/Heading';
import DebounceTextInput from 'components/DebounseTextInput';
import DownloadCSV from 'components/DownloadCSV';
import { IoMdAdd } from 'react-icons/io';
import { MdPerson } from 'react-icons/md';
import { role } from 'config/role';
import DeleteConfirmationAlert from 'components/DeleteConfirmationAlert';
import Logistics from './components/Logistics';
import Accounts from './components/Accounts';
import SalesAndMarketing from './components/SalesAndMarketing';
import AddEditStaff from './components/AddEditStaff';
import AllStaffList from './components/AllStaffList';
import { STAFF_HEADING } from './constant';
import { DELETE_STAFF, EXPORTS_USERS } from './StaffgraphQL';
import CommonStaffList from './components/CommonStaffList';
import './Staff.scss';

const Staff = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [deleteRecord, setDeleteRecord] = useState({ status: false, id: '' });
  const [activeTab, setActiveTab] = useState('All');
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [showAddRecord, setShowAddRecord] = useState({
    type: ADD_EDIT_CONSTANT.ADD,
    value: '',
    refetch: () => { },
  });

  const [searchValues, setSearchValues] = useState({
    [STAFF_HEADING.ALL]: '',
    [STAFF_HEADING.LOGISTICS]: '',
    [STAFF_HEADING.ACCOUNTS]: '',
    [STAFF_HEADING.SALESANDMARKETING]: '',
    [STAFF_HEADING.BDE]: '',
    [STAFF_HEADING.PURCHASE]: '',
  });


  const [deleteUser] = useMutation(DELETE_STAFF, {
    onCompleted: ({ deleteUser: deleteUserResponse }) => {
      toast.success(deleteUserResponse);
      setDeleteRecord({ status: !deleteRecord.status, id: '' });
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ message }) => {
        toast.error(message);
        return message;
      });
      setDeleteRecord({ status: !deleteRecord.status, id: '' });
    },
  });

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const staffTypeConfig = {
    [STAFF_HEADING.ALL]: { satffType: 'TRADER', op: 'NOT_IN', department: null },
    [STAFF_HEADING.LOGISTICS]: { satffType: role.LOGISTICS, op: 'EQ', department: 'LOGISTICS' },
    [STAFF_HEADING.ACCOUNTS]: { satffType: role.ACCOUNT, op: 'EQ', department: 'ACCOUNTS' },
    [STAFF_HEADING.SALESANDMARKETING]: {
      satffType: 'SALES_EXECUTIVE,SALES_HEAD',
      op: 'IN',
      department: 'SALES',
    },
    [STAFF_HEADING.BDE]: { satffType: role.BDE, op: 'IN', department: 'BDE' },
    [STAFF_HEADING.PURCHASE]: { satffType: 'Purchase_Manager', op: 'IN', department: 'PURCHASE' },
  };

  const activeSearchValue = searchValues[activeTab] ?? '';
  const activeStaffConfig =
    staffTypeConfig[activeTab] || staffTypeConfig[STAFF_HEADING.ALL];

  const exportFilters = useMemo(
    () => {
      const filterArr = [
        {
          key: 'userSearchFilter',
          value: activeSearchValue,
          type: 'STRING',
          op: 'LIKE',
        },
        {
          key: 'name',
          value: activeStaffConfig.department ? 'TRADER' : activeStaffConfig.satffType,
          setAttribute: 'roles',
          type: 'STRING',
          op: activeStaffConfig.department ? 'NOT_IN' : activeStaffConfig.op,
        },
      ];
      if (activeStaffConfig.department) {
        filterArr.push({
          key: 'department',
          value: activeStaffConfig.department,
          setAttribute: 'roles',
          type: 'STRING',
          op: 'EQ',
        });
      }
      filterArr.push({ ...defaultDeleteFilter });
      return {
        filter: filterArr,
        pageNo: 1,
        pageSize: 10,
        sortCol: 'id',
        sortDirection: 'DESC',
        pagination: false,
      };
    },
    [activeSearchValue, activeStaffConfig.op, activeStaffConfig.satffType, activeStaffConfig.department],
  );

  const handleViewDetail = (data) => {
    dispatch(setStaffDetails({ status: true, selectedStaff: data }));
  };

  const toggleDeleteRecord = (id) => {
    setDeleteRecord({ status: !deleteRecord.status, id });
  };

  const onDeleteConfirmation = async () => {
    try {
      await deleteUser({
        variables: { id: deleteRecord.id },
      });
    } catch (err) {
      toast.error(err);
    }
  };

  const drawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const toggleAddRecord = (value, type, refetch) => {
    setIsDrawerOpen(!isDrawerOpen);
    setShowAddRecord({ type, value, refetch });
  };

  const handleEditRoleClick = () => {
    navigate('/staff/edit-list');
  };

  const handleSearchChange = (value) => {
    setSearchValues((prev) => ({
      ...prev,
      [activeTab]: value,
    }));
  };


  return (
    <div className="staff-page">
      <div className="mb-3 top-head">
        <Heading title="Staff" />
      </div>
      <div className="d-md-flex align-items-center justify-content-between staff-top-toolbar">
        <CustomTabs
          tabs={[
            STAFF_HEADING.ALL,
            STAFF_HEADING.LOGISTICS,
            STAFF_HEADING.ACCOUNTS,
            STAFF_HEADING.SALESANDMARKETING,
            STAFF_HEADING.BDE,
            STAFF_HEADING.PURCHASE,
          ]}
          selectedTab={activeTab}
          onTabChange={toggle}
          className="mb-0 pe-5"
        />
        <div className="text-end d-flex gap-2 align-items-center staff-top-actions">
          <DebounceTextInput
            key={activeTab}
            onInputChange={handleSearchChange}
            delay={500}
            value={activeSearchValue}
            placeholder="Search by name"
            positionRight="0"
            positionTop="0"
          />
          <DownloadCSV
            lazyQuery={EXPORTS_USERS}
            filters={exportFilters}
            apiKey="exportUsers"
            classWrapper="staff-toolbar-csv"
            fileName="Staffs"
            positionTop="0"
            positionRight="0"
          />
          {/* Add Staff Button */}
          <Button
            color="primary"
            className="text-nowrap p-0 rounded-btn rounded-circle d-flex align-items-center justify-content-center"
            size="sm"
            onClick={() => toggleAddRecord('', ADD_EDIT_CONSTANT.ADD)}
            style={{ width: '30px', height: '30px', minWidth: '30px' }}
          >
            <IoMdAdd color="#fff" size={20} />
          </Button>
          {/* Edit Role Button */}
          <Button
            type="button"
            className="btn btn-primary d-flex align-items-center gap-2"
            onClick={handleEditRoleClick}
          >
            <MdPerson size={18} />
            Roles
          </Button>
        </div>
      </div>


      <DeleteConfirmationAlert
        open={deleteRecord.status}
        title="Delete"
        message="Do you really want to remove this record?"
        cancelButtonLabel="Close"
        addButtonLabel="Delete"
        onConfirm={onDeleteConfirmation}
        onCancel={toggleDeleteRecord}
      />

      {/* Add/Edit Staff Modal */}
      <FSBModal
        title={`${showAddRecord.type} Staff`}
        message=""
        open={isDrawerOpen}
        toggleAlert={drawerToggle}
        onClose={drawerToggle}
        modalClass="right-drawer"
      >
        <AddEditStaff
          toggleAddRecord={toggleAddRecord}
          type={showAddRecord.type}
          value={showAddRecord.value}
          drawerToggle={drawerToggle}
          refetch={showAddRecord.refetch}
        />
      </FSBModal>

      <TabContent
        activeTab={activeTab}
        className="position-relative mt-3 mt-md-2"
      >
        <TabPane tabId={STAFF_HEADING.ALL}>
          {activeTab === STAFF_HEADING.ALL && (
            <AllStaffList
              handleViewDetail={handleViewDetail}
              toggleAddRecord={toggleAddRecord}
              handleDelete={toggleDeleteRecord}
              searchString={searchValues[STAFF_HEADING.ALL]}
            />
          )}
        </TabPane>
        <TabPane tabId={STAFF_HEADING.LOGISTICS}>
          {activeTab === STAFF_HEADING.LOGISTICS && (
            <Logistics
              handleViewDetail={handleViewDetail}
              toggleAddRecord={toggleAddRecord}
              handleDelete={toggleDeleteRecord}
              searchString={searchValues[STAFF_HEADING.LOGISTICS]}
            />
          )}
        </TabPane>
        <TabPane tabId={STAFF_HEADING.ACCOUNTS}>
          {activeTab === STAFF_HEADING.ACCOUNTS && (
            <Accounts
              handleViewDetail={handleViewDetail}
              toggleAddRecord={toggleAddRecord}
              handleDelete={toggleDeleteRecord}
              searchString={searchValues[STAFF_HEADING.ACCOUNTS]}
            />
          )}
        </TabPane>
        <TabPane tabId={STAFF_HEADING.SALESANDMARKETING}>
          {activeTab === STAFF_HEADING.SALESANDMARKETING && (
            <SalesAndMarketing
              handleViewDetail={handleViewDetail}
              toggleAddRecord={toggleAddRecord}
              handleDelete={toggleDeleteRecord}
              searchString={searchValues[STAFF_HEADING.SALESANDMARKETING]}
            />
          )}
        </TabPane>
        <TabPane tabId={STAFF_HEADING.BDE}>
          {activeTab === STAFF_HEADING.BDE && (
            <CommonStaffList
              handleViewDetail={handleViewDetail}
              toggleAddRecord={toggleAddRecord}
              handleDelete={toggleDeleteRecord}
              department="BDE"
              searchString={searchValues[STAFF_HEADING.BDE]}
            />
          )}
        </TabPane>
        <TabPane tabId={STAFF_HEADING.PURCHASE}>
          {activeTab === STAFF_HEADING.PURCHASE && (
            <CommonStaffList
              handleViewDetail={handleViewDetail}
              toggleAddRecord={toggleAddRecord}
              handleDelete={toggleDeleteRecord}
              department="PURCHASE"
              searchString={searchValues[STAFF_HEADING.PURCHASE]}
            />
          )}
        </TabPane>
      </TabContent>
    </div>
  );
};

export default Staff;
